import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold text-textPrimary" }, "Importar validações", -1)
const _hoisted_2 = { class: "flex flex-col gap-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-textSecondary" }, "Selecione uma política para importar as validações", -1)
const _hoisted_4 = { class: "flex flex-col gap-4" }
const _hoisted_5 = { class: "flex items-center gap-3 cursor-pointer" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-textPrimary" }, "Qualificação para Repasse", -1)
const _hoisted_7 = { class: "flex items-center gap-3 cursor-pointer" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-textPrimary" }, "Qualificação Documental", -1)
const _hoisted_9 = { class: "flex items-center gap-4 w-full" }

import { ref } from 'vue'

import ModalVue from '@/components/designSystem/modals/Modal.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import type { QualificationPolicyType } from '@/modules/company/DsPolicy/components/ImportQualificationValidationsModal/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectQualificationTypeModal',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "select-type"],
  setup(__props: any, { emit }) {





const selectedType = ref<QualificationPolicyType | null>(null)

const handleSelectType = () => {
  if (selectedType.value) {
    emit('select-type', selectedType.value)
    emit('update:modelValue', false)
    selectedType.value = null
  }
}

const handleClose = () => {
  selectedType.value = null
  emit('update:modelValue', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalVue, {
    "modal-active": _ctx.modelValue,
    "has-header-border": "",
    "has-footer-border": "",
    onClose: handleClose,
    "max-width": "max-w-[600px]"
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(OutlinedButton, {
          "data-testid": "select-qualification-voltar-button",
          text: "Voltar",
          width: "100%",
          class: "!border-primary30 !text-primary30 !font-bold flex-1",
          onClick: handleClose
        }),
        _createVNode(FilledButton, {
          "data-testid": "select-qualification-selecionar-button",
          text: "Selecionar arquivos",
          width: "100%",
          disabled: !selectedType.value,
          class: "!bg-primary !text-white !font-bold hover:!bg-primary40 flex-1",
          onClick: handleSelectType
        }, null, 8, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedType).value = $event)),
              type: "radio",
              value: "TRANSFER_QUALIFICATION",
              "data-testid": "select-transfer-qualification-radio",
              class: "w-5 h-5"
            }, null, 512), [
              [_vModelRadio, selectedType.value]
            ]),
            _hoisted_6
          ]),
          _createElementVNode("label", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedType).value = $event)),
              type: "radio",
              value: "DOCUMENTARY_QUALIFICATION",
              "data-testid": "select-documental-qualification-radio",
              class: "w-5 h-5"
            }, null, 512), [
              [_vModelRadio, selectedType.value]
            ]),
            _hoisted_8
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})